import isEnumValue from '@/utils/isEnumValue'

export default function toEnumValueOrNull<E extends Record<string, string | number>>(
  enumObj: E,
  value: unknown
): E[keyof E] | null {
  return isEnumValue(enumObj, value) ? value : null
}
